// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const Container = styled.div`
    height: calc(100% - 76px);
    overflow-y: auto;
    overflow-x: hidden;
`;

export const FilterButton = styled(Button)`
    margin: 0 1.5rem 0 0;
`;